import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    priceFormatter,imagesFormatter,
    customFormatter,
    linkFormatter,
    modifyStringFormatter,
    dateFormatter,customTableSelect,
    getFieldByPathFormatter,
    displayCustomDialog
} from 'util/Utils';
import Switch from "react-switch";
import FaTimesCircle from 'react-icons/lib/fa/times-circle';
import FaCartPlus from 'react-icons/lib/fa/cart-plus';

import formatNumbers  from 'util/formatNumbers';
import {UPDATE_PRODUCT}  from "actions/actionTypes";
import config from  '../../../config';
 


class UserFavoritesListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            records: this.props.records,
         };

    }

    componentWillReceiveProps(nextProps) {
        this.setState({records: nextProps.records})
    }

    formatType(cell, row, extra){
        var foundType =  _.find(config.subscriptionTypes, function (value, key) {
            return key == row.Type
        })
        return foundType ? foundType.label  : ''
    }




    formatPrice(cell, row, extra){
        var  Price = ''
        if(_.includes(['InStock', 'Favorites', 'PriceDrop'],row.Type)) {
            if (_.get(row.Product, '_id')) {
                Price = formatNumbers.formatMoney(row.Product.Price)
            }
        }
       return  Price

    }

    formatDetails(cell, row, extra){
         var ProductName  = '',Price = '', textToMatch = '', Brand = '', Model = '', link = false
        if(row.Type== 'PriceDrop'){
            if (!_.isUndefined(row.DesirablePrice)) {
                Price = <div>{'Price limit: ' + formatNumbers.formatMoney(row.DesirablePrice)}</div>
            }
            ProductName = <div>{'Product: ' + _.get(row, ['Product', 'ProductName'], '')}</div>
             /* if subscription is related to specific Product */

            if (_.get(row, ['Product', '_id'])){
                if (  !row.Product.Deleted && row.Product.Status == 'Active' && _.get(row, 'Product.ProductVariants.0.Quantity', -1) > 0) {
                    if (_.get(row, ['Product', 'ShopifyProductHandle'])) {
                        var pageURL = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['Product', 'ShopifyProductHandle'],  ''))
                        ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                    }
                }else{
                    var pageURL  = config.getEnvironment().shopify.shopUrl + '/search?type=article%2Cpage%2Cproduct&q=' + encodeURIComponent(_.get(row, ['Product', 'ProductName'] ) )
                    ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                }
            }
                 return <div>{ProductName} {Price}  </div>

        } else   if(row.Type== 'InStock'){
            if (_.get(row, ['Product', 'ProductName'])) {
                ProductName =<div>{'Product: '+_.get(row, ['Product', 'ProductName'], '')}</div>
            }
            if (_.get(row, ['GBGProduct', '_id'])) {
                Model = <div>{'Model: '+row.GBGProduct.Model}</div>
                Brand =  <div>{'Brand: '+row.GBGProduct.Model}</div>
            }
            if (_.get(row, ['TextToMatch'])) {
                textToMatch =<div>{'Text: '+row.TextToMatch}</div>
            }
            /* if subscription is related to specific Product */

            if (_.get(row, ['Product', '_id'])){
                if (  !row.Product.Deleted && row.Product.Status == 'Active' && _.get(row, 'Product.ProductVariants.0.Quantity', -1) > 0) {
                    if (_.get(row, ['Product', 'ShopifyProductHandle'])) {
                        var pageURL = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['Product', 'ShopifyProductHandle'],  ''))
                        ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                    }
                }else{
                    var pageURL  = config.getEnvironment().shopify.shopUrl + '/search?type=article%2Cpage%2Cproduct&q=' + encodeURIComponent(_.get(row, ['Product', 'ProductName'] ) )
                    ProductName = <a target="_blank" href={pageURL}>{ _.get(row, ['Product', 'ProductName'] )} </a>
                }
            }
              return <div>{ProductName} {Model} {Brand} {textToMatch }</div>
        }else   if(row.Type== 'Favorites'){


            if ( _.get(row, ['Product', 'ShopifyProductHandle']) && _.get(row, ['Product', '_id'])   && !row.Product.Deleted &&   row.Product.Status == 'Active' && _.get(row,'Product.ProductVariants.0.Quantity',-1) > 0){ /* product exists in TUSH */
                    link = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['Product', 'ShopifyProductHandle'],_.get(row, ['SubscriptionCustomData', 'ShopifyProductHandle'])))
            } else   if (  _.get(row, ['SubscriptionCustomData', 'ProductExistsOnlyInShopify']) &&  _.get(row, ['SubscriptionCustomData', 'ShopifyProductHandle'])) { /* product does not exist in TUSH */
                  link = config.getEnvironment().shopify.productCustomerUrlTemplate.replace("[product_handle]", _.get(row, ['SubscriptionCustomData', 'ShopifyProductHandle']))
               return  <a target="_blank" href={link}>{ _.get(row, ['Product', 'ShopifyProductHandle'],_.get(row, ['SubscriptionCustomData', 'ShopifyProductName']))} </a>
            } else  if (_.get(row, ['SubscriptionCustomData', 'ShopifyProductName'] )) {
                 link = config.getEnvironment().shopify.shopUrl + '/search?type=article%2Cpage%2Cproduct&q=' + encodeURIComponent(_.get(row, ['SubscriptionCustomData', 'ShopifyProductName']) )
           }
           if (link) {
               return <a target="_blank" href={link}>{ _.get(row, ['SubscriptionCustomData', 'ShopifyProductName'],_.get(row, ['SubscriptionCustomData', 'ShopifyProductName'] ))} </a>
           }
        }

    }






    render() {
        console.log('this.state', this.state)
        var self = this;

         return (
            <div className="databases-table subscriptions-table">
                <BootstrapTable data={this.state.records} ref='table'
                                remote={ true }
                                hover={true}
                                striped={true}
                                 options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange,
                                 } }
                >


                    <TableHeaderColumn   width="80px" dataFormat={this.formatDetails.bind(this)}  dataField='ProductName' dataAlign="center" dataSort={true}>Title</TableHeaderColumn>
                    <TableHeaderColumn  dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                        hiddenOnInsert>Id</TableHeaderColumn>

                    <TableHeaderColumn width="120px"
                                       columnClassName={  'table-cell-with-image --larger-images' }
                                       dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           return imagesFormatter.call(this,  row,  rowIndex,{
                                             //  displayMultipleImages:true,
                                               imagePath:   ['Product', 'OriginalImages', 0, 'URL'],
                                               total:this.props.total,
                                               perPage:this.state.perPage,
                                               currentPage:this.props.currentPage,
                                           } )
                                       }}
                                       dataField="ProductImages"
                                       dataAlign="center"
                                       dataSort={true}>
                        Images
                    </TableHeaderColumn>
                    <TableHeaderColumn width="120px"
                                       dataFormat={this.formatPrice.bind(this)} dataAlign="center" dataSort={false}>Price</TableHeaderColumn>
                 </BootstrapTable>
                {displayCustomDialog.call(this, {
                    cancelButtonTitle:'Close',
                    buttonTitle:'doNotDisplay',
                    cancelActionHandler:()=>{
                    },
                    confirmActionHandler: (data) => {
                    },
                    modalTitle:'This product is no longer available. You can click on the product link to search for similar products',
                     dialogID: 'ProductIsNotAvailable'
                })}
            </div>
        );
    }
}


export default UserFavoritesListTable;
